import { render, staticRenderFns } from "./PointListPage.vue?vue&type=template&id=518f40ad"
import script from "./PointListPage.vue?vue&type=script&lang=js"
export * from "./PointListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports